// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"64":"6108c415","769":"7ebce20b"}[chunkId] + ".chunk.css";
};